import { ProfileInterface } from '@/shared/interfaces/profile.interface';
import { Employee } from '@/shared/models/employee.model';

export interface UserInterface {
    id?: string;
    username: string;
    firstName: string;
    lastName: string;
    secondLastName?: string;
    email: string;
    profile: ProfileInterface;
    employee: Employee;
    isActive: boolean;
    fullName?:string;
}

export class User implements UserInterface {
    public id?: string;
    public username: string;
    public firstName: string;
    public lastName: string;
    public fullName?: string | undefined;
    public secondLastName?: string;
    public email: string;
    public profile: ProfileInterface;
    public employee: Employee;
    public isActive: boolean;

    constructor() {
        this.username = '';
        this.firstName = '';
        this.lastName = '';
        this.fullName = '';
        this.email = '';
        this.profile = {
            nif: "SIN DATOS",
            // birthday: "",
            phone: '+34',
            avatar: 'SIN DATOS',
            address: 'SIN DATOS',
            state: 'SIN DATOS',
            postalCode: 'SIN DATOS',
            town: 'SIN DATOS',
            country: 'SIN DATOS',
            isAdmin: false,
            // gender: 0,
        };
        this.employee = {};
        this.isActive = true;
    }
}
